/**
 * Polyfills for Node.js modules required by tsdav
 * This file provides browser-compatible versions of Node.js core modules
 */

import { Buffer } from 'buffer';
import process from 'process';

// Make Buffer available globally
window.Buffer = Buffer;
window.process = process;

// Export for use in other modules if needed
export { Buffer, process };